import React, { useState } from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import theme from '../../theme';
import Button from '../Agents/Button';
import { LeadCaptureDialog } from '../Agents/LeadCaptureDialog';

export default function BusinessIntelligenceHero({ submitHandler, responseStatus }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { width } = useWindowDimensions();
  const isCompact = width < 700;

  return (
    <View
      style={{
        paddingTop: isCompact ? theme.spacing.space10 : theme.spacing.space16,
        paddingBottom: isCompact ? theme.spacing.space8 : theme.spacing.space16 - 8,
        paddingHorizontal: isCompact ? theme.spacing.space5 : theme.spacing.space12,
        maxWidth: 760,
        alignSelf: 'center',
        width: '100%',
      }}
    >
      <View
        style={{
          alignSelf: 'flex-start',
          backgroundColor: theme.colors.brandBlueTint,
          borderRadius: theme.radii.full,
          paddingVertical: theme.spacing.space1,
          paddingHorizontal: theme.spacing.space3 - 2,
          marginBottom: theme.spacing.space5,
        }}
      >
        <Text
          style={{
            fontFamily: theme.typography.fontMono,
            fontSize: theme.typography.size['2xs'],
            letterSpacing: theme.trackingPx(theme.typography.size['2xs'], 'widest'),
            textTransform: 'uppercase',
            color: theme.colors.accentPrimary,
          }}
        >
          Business intelligence
        </Text>
      </View>

      <Text
        style={{
          fontFamily: theme.typography.fontDisplay,
          fontWeight: theme.typography.weight.regular,
          fontSize: isCompact ? theme.typography.size['2xl'] : theme.typography.size['4xl'],
          lineHeight: theme.lineHeightPx(isCompact ? theme.typography.size['2xl'] : theme.typography.size['4xl'], 'tight'),
          letterSpacing: theme.trackingPx(isCompact ? theme.typography.size['2xl'] : theme.typography.size['4xl'], 'tight'),
          color: theme.colors.textPrimary,
          marginBottom: theme.spacing.space5 - 2,
        }}
      >
        Reporting that isn't gated behind someone else's backlog
      </Text>

      <Text
        style={{
          fontFamily: theme.typography.fontBody,
          fontSize: theme.typography.size.md,
          lineHeight: theme.lineHeightPx(theme.typography.size.md, 'normal'),
          color: theme.colors.textSecondary,
          marginBottom: theme.spacing.space8 - 2,
        }}
      >
        We connect to whatever warehouse and sources you already run — no migration, no waiting on an overloaded internal team to unblock a report. Ship it in Tableau, Power BI, or Looker, or we build the front end from scratch.
      </Text>

      <View style={{ alignSelf: 'flex-start' }}>
        <Button variant="primary" size="lg" onPress={() => setDialogOpen(true)}>
          Contact us
        </Button>
      </View>

      <LeadCaptureDialog visible={dialogOpen} onClose={() => setDialogOpen(false)} onSubmit={submitHandler} responseStatus={responseStatus} />
    </View>
  );
}
